// O estoque é contado em peças físicas; o carrinho conta vendas/ kits.
export function saleUnitsAvailable(product) {
  const pieces = Math.max(1, Number(product?.units_per_sale) || 1);
  return Math.floor(Math.max(0, Number(product?.stock) || 0) / pieces);
}

// Uma única regra para habilitar ações de compra no catálogo.
// A API de pedidos valida estoque e tamanho do kit novamente no servidor.
export function canOrderProduct(product) {
  return Boolean(product?.available) && !product.pending_review &&
    product.badge !== "demonstracao" && saleUnitsAvailable(product) > 0;
}
